import { Dialog, DialogFooter, DialogType } from "@fluentui/react";
import React, { createContext, useContext } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import TargetStore from "../productiontarget/store/TargetStore";
import { Button, InputNumber, notification, Space } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
const targetstore = createContext(TargetStore);

export const Equity = observer(() => {
  const targetStore = useContext(targetstore);

  return (
    <Dialog
      hidden={!targetStore.showEquityDialog}
      onDismiss={() => {
        targetStore.showEquityDialog = false;
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: `Set ${targetStore.mainStore.assetContextName}-OANDO Equity for ${targetStore.targetYear}`,
        subText:
          "Ensure you have an approval to change equity or oando share, as it will cause a report wide change in results",
      }}
      modalProps={{}}
      minWidth={500}
    >
      <Form layout="horizontal">
        <FormItem label={`${targetStore.targetYear} Oando Share(Equity)%`}>
          <InputNumber
            min={1}
            max={100}
            defaultValue={targetStore.mainStore.defaultEquity}
            value={targetStore.ondoShare?.equityShare}
            onChange={(value) => {
              targetStore.ondoShare.equityShare = Number(value);
            }}
          ></InputNumber>
        </FormItem>

        {targetStore.mainStore.assetContextId === 1 && (
          <>
            <FormItem label="Offshore Royalty Beniboye (%)">
              <InputNumber
                min={1}
                max={100}
                defaultValue={targetStore.offShoreRoyalty}
                value={targetStore.offShoreRoyalty}
                onChange={(value) => {
                  targetStore.offShoreRoyalty = Number(value);
                }}
              ></InputNumber>
            </FormItem>
            <FormItem label="Onshore/Swamp Royalty (%)">
              <InputNumber
                min={1}
                max={100}
                defaultValue={targetStore.onshoreRoyalty}
                value={targetStore.onshoreRoyalty}
                onChange={(value) => {
                  targetStore.onshoreRoyalty = Number(value);
                }}
              ></InputNumber>
            </FormItem>
            <FormItem label="Technical Adjustment(%)">
              <InputNumber
                min={1}
                max={100}
                defaultValue={targetStore.techAdjustment}
                value={targetStore.techAdjustment}
                onChange={(value) => {
                  targetStore.techAdjustment = Number(value);
                }}
              ></InputNumber>
            </FormItem>
          </>
        )}
      </Form>
      <DialogFooter>
        <Space>
          <Button
            type="link"
            onClick={() => {
              targetStore.showEquityDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            loading={targetStore.isSavingEquity}
            type="primary"
            onClick={async () => {
              try {
                const retVal = await targetStore.saveEquity();
                if (retVal.success) {
                  targetStore.ondoShare.equityShare = retVal.equity.equityShare;
                  notification.success({
                    message: "SPARS Feedback",
                    description: "New Equity saved successfully",
                  });
                  targetStore.showEquityDialog = false;
                }
              } catch (error) {
                notification.error({
                  key: "error",
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                targetStore.isSavingEquity = false;
              }
            }}
          >
            {`Lock-in  this Oando Equity for ${targetStore.targetYear}` }
          </Button>
        </Space>
      </DialogFooter>
      <span style={{ color: "red", fontSize: "small", fontStyle: "italic" }}>
        * This operation will be logged with your name for audit purpose
      </span>
    </Dialog>
  );
});

